import ButtonGroup from "@visa/vds/button-group";
import ButtonText from "@visa/vds/button-text";
import Dialog, { default as dialog } from "@visa/vds/dialog";
import DialogCardBody from "@visa/vds/dialog-card-body";
import DialogCardFooter from "@visa/vds/dialog-card-footer";
import DialogCardHead from "@visa/vds/dialog-card-head";
import DialogCardHeadTitle from "@visa/vds/dialog-card-head-title";
import Form from "@visa/vds/form";
import FormControl from "@visa/vds/form-control";
import Grid from "@visa/vds/grid";
import Row from "@visa/vds/row";
import React, { useEffect, useMemo, useState } from "react";
import { useForm } from "react-hook-form";
import VmidFlagSelect from "./VmidFlagSelect";
import VmidRecordStaticInfo from "./VmidRecordStaticInfo";
import { GlobalProductFlags, GlobalPerformanceFlags, EuProductFlags, EuPerformanceFlags } from "../../../_constants/DafConstants";

const VmidRecordDialog = (props) => {
  const { control, handleSubmit, formState, getValues, reset } = useForm({
    defaultValues: useMemo(() => {
      return props.vmidRecord;
    }, [props]),
  });

  const [formData, setFormData] = useState(getValues());
  const updateFormData = () => setFormData(getValues());

  const onSubmit = (data) => {
    let updateDto = {
      ...formData,
      flagOne: parseInt(formData.flagOne),
      flagTwo: parseInt(formData.flagTwo),
      flagThree: parseInt(formData.flagThree),
      flagFour: parseInt(formData.flagFour)
    };
    console.log(updateDto);
    props.handleClickSave(props.alertObj, updateDto);
  };

  useEffect(() => {
    reset(props.vmidRecord);
  }, [props.vmidRecord]);

  return (
    <Dialog
      aria-describedby="dialog-description"
      open={props.dialog.open}
      titleId="dialog-title"
    >
      <DialogCardHead style={{ width: "30vw" }}>
        <DialogCardHeadTitle id="dialog-title">Edit Flags</DialogCardHeadTitle>
      </DialogCardHead>
      <DialogCardBody id="dialog-body">
        {props.vmidRecord && (
          <Form>
            <Grid>
              <VmidRecordStaticInfo vmidRecord={props.vmidRecord} />
              <Row>
                <FormControl position="left" space="seventy">
                  <VmidFlagSelect
                    name="flagOne"
                    label="3DS DAF Global Product Participation (Flag 1)"
                    options={GlobalProductFlags}
                    control={control}
                    rules={{ required: true }}
                    handleChange={updateFormData}
                  />
                </FormControl>
              </Row>
              <Row>
                <FormControl position="left" space="seventy">
                  <VmidFlagSelect
                    name="flagTwo"
                    label="3DS DAF Global Performance Participation (Flag 2)"
                    options={GlobalPerformanceFlags}
                    control={control}
                    rules={{ required: true }}
                    handleChange={updateFormData}
                  />
                </FormControl>
              </Row>
              <Row>
                <FormControl position="left" space="seventy">
                  <VmidFlagSelect
                    name="flagThree"
                    label="3DS DAF EU Product Participation (Flag 3)"
                    options={EuProductFlags}
                    control={control}
                    rules={{ required: true }}
                    handleChange={updateFormData}
                  />
                </FormControl>
              </Row>
              <Row>
                <FormControl position="left" space="seventy">
                  <VmidFlagSelect
                    name="flagFour"
                    label="3DS DAF EU Performance Participation (Flag 4)"
                    options={EuPerformanceFlags}
                    control={control}
                    rules={{ required: true }}
                    handleChange={updateFormData}
                  />
                </FormControl>
              </Row>
            </Grid>
          </Form>
        )}
      </DialogCardBody>
      <DialogCardFooter>
        <ButtonGroup direction="right">
          <ButtonText
            colorScheme="primary"
            type="submit"
            onClick={handleSubmit(onSubmit)}
            disabled={!formState.isDirty}
          >
            Save
          </ButtonText>
          <ButtonText
            colorScheme="secondary"
            onClick={() => {
              props.setDialog({ ...dialog, open: !props.dialog.open });
            }}
          >
            Cancel
          </ButtonText>
        </ButtonGroup>
      </DialogCardFooter>
    </Dialog>
  );
};

export default VmidRecordDialog;
